import React, { useEffect, useState } from "react";
import AccountSettingSidebar from "./components/AccountSettingSidebar";

import SurveyListHeader from "../../../component/layout/MainHeader";
import Svg from "../../../component/Svg";
import Card from "../../../core/Card";
import style from "../../style.module.css";
import Input from "../../../core/Inputs/DefaultInput";
import SearchInput from "../../../core/Inputs/SearchInput";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Link } from "react-router-dom";
import {
  addRole,
  deleteRole,
  editRole,
  getModules,
  getRoleList,
} from "../../../store/actions/roleAction";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Formik } from "formik";
import { createRoleSchema } from "../../../schema/Role";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";
import NestedMenuToggle from "./NestedMenuToggle";


export default function UserRoles() {
  const dispatch = useDispatch();
  const {
    roleDataLoading: loading,
    roleData: roleList,
    isAddingRole,
    moduleData: moduleData,
    deleteMessage,
    isDeletingRole,
  } = useSelector((state) => state.roleData);

  const [selectedDeleteRole, setSelectedDeleteRole] = useState(null);
  const [roleListForSelect, setRoleListForSelect] = useState([]);
  const [filteredRoleListForSelect, setFilteredRoleListForSelect] = useState(
    []
  );
  const [permissionModalData, setPermissionModalData] = useState(null);
  const [isEdit, setIsEdit] = React.useState(false);
  const [permision, setPermisioin] = React.useState([]);
  const [id, setId] = React.useState("");
  const [modalName, setModalName] = React.useState("");
  const [parentId, setParentId] = React.useState(null);
  const [serverParams, setServerParams] = useState({
    startingLimit: 0,
    resultsPerPage: 8,
    search: "",
  });

  const getRoles = () => {
    dispatch(getRoleList(serverParams));
  };

  const getAllModules = async () => {
    dispatch(getModules());
  };

  const editApi = async (payload) => {
    dispatch(editRole(payload));
  };
  const addApi = async (payload) => {
    dispatch(addRole(payload));
  };
  const deleteapi = async () => {
    // e.preventDefault();
    console.log("selectedDeleteRole", selectedDeleteRole);
    const payload = {
      role_id: selectedDeleteRole.id,
    };
    dispatch(deleteRole(payload));
  };

  const openRoleAddEditModal = async (row = null, action = null) => {
    if (row && action) {
      let updatedData = roleListForSelect.filter(
        (item) => item.value !== row.id
      );
      setFilteredRoleListForSelect(updatedData);
      setIsEdit(true);
      setId(row.id);
      setPermissionModalData(null);
      setTimeout(() => {
        setPermissionModalData(JSON.parse(row?.module_permissions));
      }, 0);
      setModalName(row.role_name);
      setParentId(row.parent_id);
    } else {
      setFilteredRoleListForSelect(roleListForSelect);
      setIsEdit(false);
      setId("");
      setPermissionModalData(null);
      setTimeout(() => {
        setPermissionModalData(JSON.parse(JSON.stringify(moduleData)));
      }, 0);
      setModalName("");
      setParentId("");
    }
    let addRole = document.getElementById("addRoleModal");
    let roleModal = window.bootstrap.Modal.getOrCreateInstance(addRole);
    if (roleModal && !roleModal._isShown) {
      roleModal.show();
    }
  };

  const closeRoleAddEditModal = () => {
    setIsEdit(false);
    setId("");
    setModalName("");
    setParentId("");
    let addRole = document.getElementById("addRoleModal");
    let roleModal = window.bootstrap.Modal.getOrCreateInstance(addRole);
    if (roleModal && roleModal._isShown) {
      roleModal.hide();
      getRoles();
    }
  };
  const handleResetForm = () => {
    setModalName("");
    setFilteredRoleListForSelect("")
    setPermisioin("")
    setPermissionModalData(null);
    getRoles()

  }
  useEffect(() => {
    if (!isAddingRole) {
      closeRoleAddEditModal();
    }
    if (isAddingRole) {
      openRoleAddEditModal();
    }
  }, [isAddingRole]);

  useEffect(() => {
    if (!isDeletingRole) {
      let deleteRoleModal = document.getElementById("deleteModal");
      let delRoleModal =
        window.bootstrap.Modal.getOrCreateInstance(deleteRoleModal);
      if (delRoleModal && delRoleModal._isShown) {
        delRoleModal.hide();
        getRoles();
      }

    }
  }, [isDeletingRole]);

  useEffect(() => {
    getAllModules();
  }, []);

  useEffect(() => {
    getRoles();
  }, [serverParams]);

  useEffect(() => {
    let roleOptions = [];
    roleList.map((ele) => {
      roleOptions.push({
        value: ele.id,
        label: ele.role_name,
      });
    });
    setRoleListForSelect(roleOptions);
  }, [roleList]);

  useEffect(() => {
    setPermissionModalData(moduleData);
  }, [moduleData]);

  useEffect(() => {
    setPermisioin(permissionModalData);
  }, [permissionModalData]);

  useEffect(() => {
    if (deleteMessage) {
      toast.error(deleteMessage);
    }
  }, [deleteMessage]);

  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
        <SurveyListHeader />
        <div id="viewport" className="d-flex">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 variable-pg-content">
              {/* breadcrumbs here */}
              <div className="custom-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link
                        to="/admin/dashboard"
                        className="home-item"
                        title="Dashboard"
                      >
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">Settings</Link>
                    </li>
                    {/* <li className="breadcrumb-item">
                        <Link to="/admin/settings/user-permissions">
                          User & Teams
                        </Link>
                      </li> */}
                    <li
                      className="breadcrumb-item active"
                      aria-current="page"
                    >
                      <strong>Roles</strong>
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="survey-main-container">
                <div className="page-heading d-lg-none">
                  <div className="d-flex align-items-start">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>Roles</h1>
                    </div>
                  </div>
                </div>
                <div className="role-wrapper flex-grow-1">
                  <div className="pagesRow varPg">
                    <div className="page-heading heading-section-new mb-3">
                      <p>Roles are predefined sets of permissions and responsibilities that are assigned to users.</p>
                    </div>
                    {/* Empty State of User Role */}

                    <div className="table-wrapper-view">
                      <div className="search-filter d-md-flex align-items-center">
                        <div className="flex-grow-1 pe-0 pe-md-3 mb-3 mb-md-0">
                          <SearchInput
                            className="custom-search-input"
                            type="def"
                            value={serverParams.search}
                            view="outlined"
                            color="primary"
                            placeholder="Search"
                            fill={true}
                            // onChange={(e) => {
                            //   // setServerParams({
                            //   //   ...serverParams,
                            //   //    search: e.target.value,
                            //   // });
                            // }}
                            onClear={() => {
                              setServerParams({
                                ...serverParams,
                                search: "",
                              });
                            }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                setServerParams({
                                  ...serverParams,
                                  search: e.target.value, // Use searchText instead of e.target.value
                                });
                              }
                            }}

                            onSearchIconClick={(e) => {
                              // Implement your search logic here
                              setServerParams({
                                ...serverParams,
                                search: document.querySelector('.custom-search-input > input').value, // Use searchText instead of e.target.value
                              });

                            }}

                            onClick={(e) => {
                              setServerParams({
                                ...serverParams,
                                search: e.target.value, // Use searchText instead of e.target.value
                              });
                              // setSearchText(searchText)
                            }}
                          />

                        </div>
                        {window.modulePermissions.M4.add == 1 && (
                          <div className="button-wrap">
                            <button
                              type="button"
                              className="btn btn-primary add-btn"
                              onClick={() => {
                                setIsEdit(false);
                                openRoleAddEditModal();
                              }}
                              // data-bs-toggle="modal"
                              // data-bs-target="#addRoleModal"
                              srno="1"
                              value="1"
                            >
                              <Svg name="plus" /> Create{" "}
                            </button>
                          </div>
                        )}
                      </div>

                      {roleList.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table mb-0">
                            <thead>
                              <tr>
                                {/* <th scope="col">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                    />
                                  </th> */}
                                {/* <th scope="col">S.No</th> */}
                                <th scope="col">Name</th>
                                <th scope="col">Date added</th>
                                <th scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {roleList.map((role, roleIndex) => (
                                <tr key={roleIndex}>
                                  {/* <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                      />
                                    </td> */}
                                  {/* <td>{roleIndex + 1}</td> */}
                                  <td>{role.role_name}</td>
                                  <td>
                                    {moment(role.add_date_time).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </td>
                                  <td>
                                    <div className="d-flex">
                                      {role.role_name != 'Admin' && (
                                        <>
                                          {window.modulePermissions.M4.edit == 1 && (
                                            <a
                                              href="#"
                                              className="action-btn"
                                              onClick={() => {
                                                openRoleAddEditModal(role, "edit");
                                              }}
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Edit Role"
                                            >
                                              <Svg name="table-edit" />
                                            </a>
                                          )}
                                          {window.modulePermissions.M4.del == 1 && (
                                            <a
                                              href="#"
                                              data-bs-toggle="modal"
                                              data-bs-target="#deleteModal"
                                              className="action-btn"
                                              onClick={() => setSelectedDeleteRole(role)}
                                              data-toggle="tooltip"
                                              data-placement="top"
                                              title="Delete Role"
                                            >
                                              <Svg name="table-delete" />
                                            </a>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p className="text-center">There are no records to display</p>
                      )}

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal fade setting-modal"
        id="addRoleModal"
        tabIndex={-1}
        aria-labelledby="addRoleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div className={"formvawrapper modal-sm" + " " + style.wrapper}>
                  <Card
                    view="raised"
                    className={"formstyle p-12px" + " " + style.card}
                  >
                    <div className="modal-heading">
                      <h4>{isEdit ? "Edit" : "Add New"} Role</h4>
                    </div>
                    <Formik
                      initialValues={{
                        name: modalName,
                        permissions: permissionModalData,
                        parent_id: parentId,
                      }}
                      enableReinitialize
                      validationSchema={createRoleSchema}
                      onSubmit={(values, { setSubmitting, resetForm }) => {
                        if (isEdit) {
                          const payload = {
                            role_id: id,
                            name: values.name,
                            permissions: JSON.stringify(values.permissions),
                            parent_id: values.parent_id,
                          };
                          editApi(payload);
                        } else {
                          const payload = {
                            name: values.name,
                            permissions: JSON.stringify(values.permissions),
                            parent_id: values.parent_id,
                          };
                          addApi(payload);
                        }
                        let addUserSuccessModal =
                          document.getElementById("addUserSuccess");
                        let modal =
                          window.bootstrap.Modal.getOrCreateInstance(
                            addUserSuccessModal
                          );
                        if (modal && !modal._isShown) {
                          modal.show();
                        }
                      }}
                    >
                      {({
                        values,
                        errors,
                        resetForm,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div className="form-wrapper">
                            <div className="form-group mb-12px position-relative">
                              <label>Role Name</label>
                              <Input
                                type="text"
                                view="outlined"
                                dense={false}
                                color="default"
                                label=""
                                placeholder="Enter role name..."
                                clearButton={true}
                                success={false}
                                error={false}
                                fill={true}
                                errorHelperText={null}
                                className={"formsinput"}
                                name="name"
                                value={values.name}
                                onChange={handleChange}
                                maxLength={100}
                              />
                              {errors.name && (
                                <div className="validation-msg">
                                  {errors.name}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-12px position-relative cstom-select">
                              <label>Select Parent Role</label>
                              <CreatableSelect
                                // isClearable
                                options={filteredRoleListForSelect}
                                value={
                                  roleListForSelect
                                    ? roleListForSelect.find(
                                      (option) =>
                                        option.value === values.parent_id
                                    )
                                    : ""
                                }
                                onChange={(e) => {
                                  setFieldValue("parent_id", e.value);
                                }}
                              />
                            </div>
                            <div className="form-group mb-12px">
                              <label className="permission-label">Permissions</label>
                              <div className="permission-wrapper">
                                <div className="row">
                                  {permissionModalData &&
                                    Object.keys(permissionModalData).map(
                                      (obj, key) => (
                                        <div className="col-lg-12 mb-3" key={key}>
                                          {console.log("data", obj)}
                                          <h5>
                                            {permissionModalData[obj]?.name}
                                          </h5>
                                          <div className="check-wrap">
                                            {Object.prototype.hasOwnProperty.call(
                                              permissionModalData[obj],
                                              "view"
                                            ) && (
                                                <div className="form-check form-check-inline me-3">
                                                  <input
                                                    id={"view" + key}
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    defaultChecked={
                                                      permissionModalData[obj]
                                                        .view === 1
                                                        ? true
                                                        : false
                                                    }
                                                    value={
                                                      permissionModalData[obj]
                                                        .view === 1
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(e) => {
                                                      let change = (permision[
                                                        obj
                                                      ]["view"] = e.target.checked
                                                          ? 1
                                                          : 0);
                                                      setPermisioin(
                                                        (permision) => {
                                                          permision[obj]["view"] =
                                                            e.target.checked
                                                              ? 1
                                                              : 0;
                                                          return {
                                                            ...permision,
                                                          };
                                                        }
                                                      );
                                                      let changePermission = {
                                                        ...permision,
                                                        change,
                                                      };
                                                      setFieldValue(
                                                        "permissions",
                                                        changePermission
                                                      );
                                                    }}
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    htmlFor={"view" + key}
                                                  >
                                                    View
                                                  </label>
                                                </div>
                                              )}
                                            {Object.prototype.hasOwnProperty.call(
                                              permissionModalData[obj],
                                              "add"
                                            ) && (
                                                <div className="form-check form-check-inline me-3">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    defaultChecked={
                                                      permissionModalData[obj]
                                                        .add === 1
                                                        ? true
                                                        : false
                                                    }
                                                    value={
                                                      permissionModalData[obj]
                                                        .add === 1
                                                        ? true
                                                        : false
                                                    }
                                                    id={"add" + key}
                                                    onChange={(e) => {
                                                      let change = (permision[
                                                        obj
                                                      ]["add"] = e.target.checked
                                                          ? 1
                                                          : 0);
                                                      setPermisioin(
                                                        (permision) => {
                                                          permision[obj]["add"] =
                                                            e.target.checked
                                                              ? 1
                                                              : 0;
                                                          return {
                                                            ...permision,
                                                          };
                                                        }
                                                      );
                                                      let changePermission = {
                                                        ...permision,
                                                        change,
                                                      };
                                                      setFieldValue(
                                                        "permissions",
                                                        changePermission
                                                      );
                                                    }}
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    htmlFor={"add" + key}
                                                  >
                                                    Write
                                                  </label>
                                                </div>
                                              )}
                                            {Object.prototype.hasOwnProperty.call(
                                              permissionModalData[obj],
                                              "edit"
                                            ) && (
                                                <div className="form-check form-check-inline me-3">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    defaultChecked={
                                                      permissionModalData[obj]
                                                        .edit === 1
                                                        ? true
                                                        : false
                                                    }
                                                    value={
                                                      permissionModalData[obj]
                                                        .edit === 1
                                                        ? true
                                                        : false
                                                    }
                                                    id={"edit" + key}
                                                    onChange={(e) => {
                                                      let change = (permision[
                                                        obj
                                                      ]["edit"] = e.target.checked
                                                          ? 1
                                                          : 0);
                                                      setPermisioin(
                                                        (permision) => {
                                                          permision[obj]["edit"] =
                                                            e.target.checked
                                                              ? 1
                                                              : 0;
                                                          return {
                                                            ...permision,
                                                          };
                                                        }
                                                      );
                                                      let changePermission = {
                                                        ...permision,
                                                        change,
                                                      };
                                                      setFieldValue(
                                                        "permissions",
                                                        changePermission
                                                      );
                                                    }}
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    htmlFor={"edit" + key}
                                                  >
                                                    Read
                                                  </label>
                                                </div>
                                              )}
                                            {Object.prototype.hasOwnProperty.call(
                                              permissionModalData[obj],
                                              "del"
                                            ) && (
                                                <div className="form-check form-check-inline me-3">
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    defaultChecked={
                                                      permissionModalData[obj]
                                                        .del === 1
                                                        ? true
                                                        : false
                                                    }
                                                    value={
                                                      permissionModalData[obj]
                                                        .del === 1
                                                        ? true
                                                        : false
                                                    }
                                                    id={"del" + key}
                                                    onChange={(e) => {
                                                      let change = (permision[
                                                        obj
                                                      ]["del"] = e.target.checked
                                                          ? 1
                                                          : 0);
                                                      setPermisioin(
                                                        (permision) => {
                                                          permision[obj]["del"] =
                                                            e.target.checked
                                                              ? 1
                                                              : 0;
                                                          return {
                                                            ...permision,
                                                          };
                                                        }
                                                      );
                                                      let changePermission = {
                                                        ...permision,
                                                        change,
                                                      };
                                                      setFieldValue(
                                                        "permissions",
                                                        changePermission
                                                      );
                                                    }}
                                                  />
                                                  <label
                                                    className="form-check-label ms-2"
                                                    htmlFor={"del" + key}
                                                  >
                                                    Delete{" "}
                                                  </label>
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                      )
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="button-wrap d-flex justify-content-end">
                            <button
                              type="button"
                              className="btn btn-bordered color-cancel"
                              // onClick={() => {
                              //   resetForm();
                              // }}
                              onClick={handleResetForm}
                              data-bs-dismiss="modal"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary add-btn ms-3"
                            >
                              {/* <Svg name="plus" /> */}
                              {/* {isEdit ? "Edit" : "Add"} */}
                              Save
                            </button>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteModal"
        tabIndex={-1}
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div
                className={
                  "formvawrapper delete-modal-wrap modal-setting-medium"
                }
              >
                <div className={"formstyle p-md-0"}>
                  <div className="delete-body-wrap delete-language">
                    <div className="heading">
                      <h3>Delete user role</h3>
                      <p>
                        By deleting the user role you will be deleting the user
                        role from all the Servers and their permission to
                        access.
                      </p>
                    </div>

                    <div className="text-normal">

                    </div>

                    <div className="button-wrap d-flex justify-content-end">

                      <button
                        type="button"
                        className="btn btn-bordered color-cancel"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-delete ms-3"
                        onClick={deleteapi}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
